document.addEventListener("DOMContentLoaded", () =>
{
    document.querySelectorAll(".EPiServerForms").forEach(form =>
    {
        const formElements = form.querySelectorAll('.Form__Element');
        const ids = new Set();
        formElements.forEach(block =>
        {
            const id = block.getAttribute('data-f-element-name');
            if (id && ids.has(id)) {
                block.remove();
            } else if (id) {
                ids.add(id);
            }
        });
    });
});